import { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import afterSurveyDesktop from '../../../../assets/images/after-survey-landing/after-survey-desktop.png';
import afterSurveyMobile from '../../../../assets/images/after-survey-landing/after-survey-mobile.png';
import qrCode from '../../../../assets/images/after-survey-landing/qr.png';
import { v2026PP16361 } from '../../../../constants/veeva';
import { downloadAppLinks } from '../../../common/footer/download-app';
import { Veeva } from '../../../common/veeva';
import { Breakpoints } from '../../../../themes/default';
import { useStyles } from './after-survey-screen.styles';

const afterSurveyDownloadAppLinks = [
  downloadAppLinks[0],
  downloadAppLinks[1],
  downloadAppLinks[2],
];

export const AfterSurveyScreen = (): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <main className={classes.main} data-testid="after-survey-screen">
      <picture className={classes.confirmation}>
        <source
          srcSet={afterSurveyDesktop}
          media={`(min-width: ${Breakpoints.md}px)`}
        />
        <source
          srcSet={afterSurveyMobile}
          media={`(min-width: ${Breakpoints.xs}px)`}
        />
        <img
          src={afterSurveyDesktop}
          alt=""
          className={classes.confirmationImage}
        />
      </picture>

      <div className={classes.download}>
        <h1 id="download-title">
          {intl.formatMessage(
            { id: 'afterSurveyScreen.download.title' },
            { sup: (chunks: ReactNode) => <sup>{chunks}</sup> },
          )}
        </h1>
        <ul className={classes.storeLinks}>
          {afterSurveyDownloadAppLinks.map(({ href, Icon, testId, id }) => (
            <li key={testId}>
              <a
                href={href}
                target='_blank'
                rel='noopener noreferrer'
                aria-label={intl.formatMessage({ id: `afterSurveyScreen.storeLink.${id}` })}
                data-testid={testId}
              >
                <Icon className={classes.storeIcon} aria-hidden="true" />
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div className={classes.qrPanel}>
        <div className={classes.qrCopy}>
          <h2 id="qr-title">
            {intl.formatMessage(
              { id: 'afterSurveyScreen.qr.title' },
              { noWrap: (chunks: ReactNode) => <span className={classes.noWrap}>{chunks}</span> })}
          </h2>
          <p>{intl.formatMessage(
            { id: 'afterSurveyScreen.qr.description' },
            {
              noWrap: (chunks: ReactNode) => <span className={classes.noWrap}>{chunks}</span>,
              block: (chunks: ReactNode) => <span className={classes.block}>{chunks}</span>,
            })}</p>
        </div>
        <img
          className={classes.qrImage}
          src={qrCode}
          alt={intl.formatMessage({ id: 'afterSurveyScreen.qr.alt' })}
          width={250}
          height={250}
        />
      </div>

      <div className={classes.veeva}>
        <Veeva veevaNumber={v2026PP16361} />
      </div>
    </main>
  );
};
